<template>
  <a :href="props.card.link" class="image-card flex flex-col md:flex-row p-4 md:p-3 rounded-lg hover:bg-gray-50 gap-6 md:gap-4">
    <div class="w-full md:w-36 h-40 md:h-20 rounded-md bg-center bg-cover" :style="['background-image: url(' + props.card.image + ')']" style="min-width: 144px !important"></div>
    <div>
      <div class="text-base font-semibold pb-1 leading-6 text-gray-900"><h3 v-html="replaceWithBr(props.card.label)"></h3></div>
      <div class="text-sm font-normal leading-5 text-gray-600 line-clamp-2"><p v-html="replaceWithBr(props.card.text)"></p></div>
      <div class="hidden items-center gap-2 pt-3">
        <div class="text-sm font-semibold text-primary-500 leading-5">Lees meer</div>
        <a :href="props.card.link">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.16663 10H15.8333M15.8333 10L9.99996 4.16669M15.8333 10L9.99996 15.8334" stroke="#2970FF" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </a>
      </div>
    </div>
  </a>
</template>

<script setup>
import { useHeaderStore } from '@/stores'

const headerStore = useHeaderStore()

const props = defineProps(['card'])

function replaceWithBr(text) {
  return text.replace(/\n/g, "<br />")
}

</script>
